//import AOS from 'aos';
//import 'aos/dist/aos.css';

/**
 * Dynamiczne ładowanie Google Maps API
 */
async function loadGoogleMapsAPI(apiKey) {
    return new Promise((resolve, reject) => {
        if (window.google && window.google.maps && window.google.maps.LatLng) {
            resolve();
            return;
        }

        const script = document.createElement('script');
        // Ładujemy bez libraries=marker bo używamy klasycznego Marker
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&v=weekly&loading=async`;
        script.async = true;
        script.defer = true;

        script.onload = () => {
            // Poczekaj aż API będzie w pełni dostępne
            const checkGoogleMaps = () => {
                if (window.google && window.google.maps && window.google.maps.LatLng) {
                    resolve();
                } else {
                    setTimeout(checkGoogleMaps, 50);
                }
            };
            checkGoogleMaps();
        };
        script.onerror = () => reject(new Error('Google Maps API failed to load'));

        document.head.appendChild(script);
    });
} export function setCookie(name, value, days) {
    var now = new Date();
    var expTime = now.getTime() + days * 24 * 60 * 60 * 1000;
    var expDate = new Date(expTime);
    document.cookie = name + "=" + value + "; EXPIRES=" + expDate.toGMTString() + "; path=/";
}
export function getCookie(name) {

    var start = document.cookie.indexOf(name + "=");
    if (start == -1)
        return null;
    var len = start + name.length + 1;
    var end = document.cookie.indexOf(";", len);
    if (end == -1)
        end = document.cookie.length;
    return document.cookie.substring(len, end)
}

export async function initializeMap(map0) {
    // Dynamiczne ładowanie Google Maps API
    if (!window.google || !window.google.maps) {
        const apiKey = map0.dataset.apikey;
        if (!apiKey) {
            console.error('Brak klucza API Google Maps w dataset.apikey');
            return;
        }

        // Ładowanie Google Maps API
        await loadGoogleMapsAPI(apiKey);
    }

    // Upewnij się że Google Maps API jest w pełni załadowane
    if (!window.google || !window.google.maps || !window.google.maps.LatLng) {
        console.error('Google Maps API nie zostało prawidłowo załadowane');
        return;
    }

    var mapData = JSON.parse(map0.dataset.map.replace(/'/g, '"'));

    var mapOptions = {
        center: new google.maps.LatLng(mapData[0]['map-lat'], mapData[0]['map-lng']),
        zoom: 14,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: true,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        gestureHandling: 'cooperative'
    };

    var map = new google.maps.Map(map0, mapOptions);

    // Dodaj style po utworzeniu mapy
    map.setOptions({
        styles: [
            {
                elementType: 'all',
                stylers: [
                    { saturation: -100 }
                ]
            }
        ]
    });

    map.myOrigins = map.getCenter();
    var bounds = new google.maps.LatLngBounds();

    // UWAGA: Używamy klasycznego google.maps.Marker
    // AdvancedMarkerElement wymaga Map ID skonfigurowanego w Google Cloud Console
    // Klasyczny Marker jest deprecated ale nadal działa i będzie wspierany przez min. 12 miesięcy
    const image = "../wp-content/themes/pychynski/images/marker.png";

    mapData.forEach(function (elem) {
        elem.marker = new google.maps.Marker({
            position: new google.maps.LatLng(elem['map-lat'], elem['map-lng']),
            map: map,
            icon: image
        });

        bounds.extend(elem.marker.position);

        elem.marker.addListener('click', function () {
            window.open(elem['map-link']);
        });
    });

    if (mapData.length > 1) {
        map.fitBounds(bounds);
    }
}
/**
* init menu trigger (onClisk)
 */
export const initMenuTrigger = () => {
    const menuTrigger = document.querySelector('.menuTrigger');
    if (menuTrigger) {
        document.querySelectorAll('.menuTrigger').forEach((item) => item.addEventListener('click', e => {
            document.body.classList.toggle('showMenu');
        }));
    }
}




/**
 * add/remove hideScrolledMenu class to body based on scroll direction and position
 */
export const addHideScrolledMenuClass = () => {
    const scrollFactor = 0.4; // Procent wysokości ekranu
    let lastScrollY = window.scrollY;
    let halfScreenHeight = window.innerHeight * scrollFactor;


    const handleScroll = () => {
        const currentScrollY = window.scrollY;

        if (currentScrollY > 0) {
            document.body.classList.add('scroll');
        } else {
            document.body.classList.remove('scroll');
        }

        // Sprawdzamy czy przekroczyliśmy połowę wysokości ekranu
        if (currentScrollY > halfScreenHeight) {
            // Sprawdzamy kierunek scrollowania
            if (currentScrollY > lastScrollY) {
                // Scrollujemy w dół - dodajemy klasę
                document.body.classList.add('hideScrolledMenu');
            } else {
                // Scrollujemy w górę - usuwamy klasę
                document.body.classList.remove('hideScrolledMenu');
            }
        } else {
            // Jeśli jesteśmy powyżej połowy ekranu, zawsze usuwamy klasę
            document.body.classList.remove('hideScrolledMenu');
        }

        lastScrollY = currentScrollY;
    };

    // Dodajemy event listener z throttling dla lepszej wydajności
    let ticking = false;
    const throttledScroll = () => {
        if (!ticking) {
            requestAnimationFrame(() => {
                handleScroll();
                ticking = false;
            });
            ticking = true;
        }
    };

    window.addEventListener('scroll', throttledScroll, { passive: true });

    // Aktualizujemy halfScreenHeight przy zmianie rozmiaru okna
    window.addEventListener('resize', () => {
        halfScreenHeight = window.innerHeight * scrollFactor;
    }, { passive: true });
}



/**
 * add class 'gallery-item', fix for fancybox plugin
 * @param {string} cn 
 */
export const galleryAddItemClass = (cn) => {
    const galleryItemFancybox = document.querySelectorAll(cn);
    if (galleryItemFancybox && galleryItemFancybox.length > 0) {
        galleryItemFancybox.forEach(item => {
            item.classList.add('gallery-item');
        });
    }
}

/**
 * add id to gallery holder, fix for fancybox plugin ...
 * @param {string} gallery 
 */
export const addFancyboxFixForGallery = (gallery) => {
    const galleryFancybox = document.querySelectorAll(gallery);
    if (galleryFancybox && galleryFancybox.length > 0) {
        galleryFancybox.forEach(gallery => {
            const galleryAnchors = gallery.querySelectorAll(':scope a');
            const galeeryId = 'gal' + (Math.floor(Math.random() * 100));
            if (galleryAnchors && galleryAnchors.length > 0) {
                galleryAnchors.forEach(galeeryAnchor => {
                    if (!galeeryAnchor.dataset.gallery) {
                        galeeryAnchor.dataset.gallery = galeeryId;
                    }
                    if (!galeeryAnchor.dataset.caption) {
                        galeeryAnchor.dataset.caption = galeeryAnchor.nextSibling ? galeeryAnchor.nextSibling.innerHTML : '';
                    }
                });
            }
        });
    }
}

/**
 * add close on click for cookies box
 */
const hideCookies = () => {
    document.querySelector('.cookies').classList.add('hide');
}
export const addCloseCookies = () => {
    const cookieBtn = document.querySelector('.cookies__close');
    if (cookieBtn) {
        cookieBtn.addEventListener('click', e => {
            setCookie('hideCookieAlert', 1, 360);
            hideCookies();
            return false;
        });
    }
    if (getCookie('hideCookieAlert')) {
        hideCookies();
    }
}



/**
 * init form script fix
 */
export const initForm = () => {

    var wpcf7Elm = document.querySelectorAll('.wpcf7');
    const inputs = document.querySelectorAll(
        '.wpcf7 input[type=text], ' +
        '.wpcf7 input[type=email], ' +
        '.wpcf7 input[type=tel], ' +
        '.wpcf7 textarea, ' +
        '.wpcf7 select'
    );
    if (inputs) {
        inputs.forEach(item => {

            if (item.nodeName == 'SELECT') item.value = '';
            item.addEventListener('focus', e => e.target.parentNode.parentNode.querySelector(':scope label').classList.add('show'));
            item.addEventListener('focusout', e => {
                if (e.target.value == '' || e.target.value == null) {
                    e.target.parentNode.parentNode.querySelector(':scope label').classList.remove('show')
                }
            });

            var observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.attributeName === 'class' && mutation.target.classList.contains('wpcf7-not-valid')) {
                        mutation.target.parentNode.parentNode.classList.add('error');
                    } else if (mutation.attributeName === 'class') {
                        mutation.target.parentNode.parentNode.classList.remove('error');

                    }
                });

            });

            observer.observe(item, { attributes: true });
        });
    }
    if (document.querySelector('.wpcf7 input[type=file]')) {
        document.querySelector('.wpcf7 input[type=file]').addEventListener('change', function (event) {
            if (event.target.files[0].name != '') {
                document.querySelector('.cfFile .cover').innerHTML = event.target.files[0].name;
                document.querySelector('.cfFile .clean').classList.add('show');
            }
        });
    }
    if (document.querySelector('.cfFile .clean')) {
        document.querySelector('.cfFile .clean').addEventListener('click', function (event) {
            let cover = document.querySelector('.cfFile .cover');
            cover.innerHTML = cover.dataset.text;
            document.querySelector('.wpcf7 input[type=file]').value = '';
            event.target.classList.remove('show');
        });
    }



    let submitInputs = document.querySelectorAll('.wpcf7 input[type=submit]');
    var observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.attributeName === 'disabled' && mutation.target.disabled) {
                mutation.target.removeAttribute('disabled');
            }
        });
    });
    submitInputs.forEach(button => {
        observer.observe(button, { attributes: true });
        button.removeAttribute('disabled');
        button.addEventListener('click', e => {
            const form = button.closest('form');
            if (form.classList.contains('submitting') || form.classList.contains('beforesubmit')) {
                e.preventDefault();
                return false;
            }
        });
    });




    if (wpcf7Elm) {
        wpcf7Elm.forEach(wpcf7ElmItem => {
            wpcf7ElmItem.addEventListener('wpcf7invalid', function (event) {
                document.querySelectorAll('.wpcf7-not-valid')
                    .forEach((item) => {
                        if (item.value !== "") {
                            item.parentNode.parentNode.querySelector(':scope label').classList.add('show');
                        }
                    });
                const scrollTarget = jQuery(wpcf7ElmItem).offset().top - 100;
                jQuery('html,body').animate({ scrollTop: scrollTarget + 'px' }, 500);
            }, false);
            wpcf7ElmItem.addEventListener('wpcf7mailsent', function (event) {
                document.querySelectorAll('.wpcf7 input').forEach((item) => {
                    const label = item.parentNode.parentNode.querySelector(':scope label');
                    if (label) {
                        label.classList.remove('show');
                    }
                });
                const scrollTarget = jQuery(wpcf7ElmItem).offset().top - 100;
                jQuery('html,body').animate({ scrollTop: scrollTarget + 'px' }, 500);
                document.querySelector('.cfFile .clean').click();
            }, false);
        });
    }
}



/**
 * google map (API) init
 */
export const googleMapInit = async () => {
    var map = document.querySelector('.contactMap');
    if (map) {
        // Nowoczesny sposób ładowania Google Maps API
        try {
            await initializeMap(map);
        } catch (error) {
            console.error('Error initializing map:', error);
        }
    }
}



export const initLoadNews = () => {
    if (!!window.IntersectionObserver) {
        let newsCanBeLoaded = true;
        const newsAjaxTrigger = document.querySelector('.newsAjaxTrigger');
        let addNewsObserver = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                if (newsCanBeLoaded) {
                    loadNews();
                }
            }
        });

        if (newsAjaxTrigger) {
            addNewsObserver.observe(newsAjaxTrigger);
        }

        const loadNews = () => {
            const newsAjaxTrigger = document.querySelector('.newsAjaxTrigger');
            if (newsAjaxTrigger) {
                newsCanBeLoaded = false;
                newsAjaxTrigger.classList.add('show');
                const formData = new FormData();
                formData.append('action', 'loadmore');
                formData.append('query', ajaxParams.posts);
                formData.append('page', ajaxParams.current_page);
                fetch(ajaxParams.ajaxurl, {
                    method: "post",
                    body: formData
                })
                    .then(res => res.text())
                    .then(res => {
                        if (res) {
                            newsCanBeLoaded = true;
                            ajaxParams.current_page++;
                            newsAjaxTrigger.classList.remove('show');
                            document.querySelector('.newsList').insertAdjacentHTML('beforeend', res);
                        } else {
                            newsCanBeLoaded = false;
                            document.querySelector('.newsAjaxTrigger').remove();
                            addNewsObserver.disconnect();
                        }

                    });
            }

        }
    }
}

const faqServiceTrigger = (trigger, faqHolder) => {
    const tParent = trigger.parentNode;
    const tContent = tParent.querySelector(':scope .gFaq__content');

    [...faqHolder.querySelectorAll(':scope .gFaq__item.active')].forEach((item) => {
        if (!item.isSameNode(tParent)) {
            item.classList.remove('active');
            jQuery(item.querySelector(':scope .gFaq__content')).stop(true, true).slideUp(500)
        }
    });

    if (!tParent.classList.contains('active')) {
        typeof jQuery == "function" ? jQuery(tContent).stop(true, true).slideDown(500) : null;
    } else {
        typeof jQuery == "function" ? jQuery(tContent).stop(true, true).slideUp(500) : null;
    }
    tParent.classList.toggle('active');

}

export const faqService = () => {
    const faq = document.querySelectorAll('.gFaq');

    if (faq.length > 0) {
        [...faq].forEach((faqItem) => {
            const triggers = faqItem.querySelectorAll(':scope .gFaq__trigger');
            if (triggers.length > 0) {
                [...triggers].forEach((trigger) => {
                    trigger.addEventListener('click', () => faqServiceTrigger(trigger, faqItem));
                });
            }

        });
    }

}

export const initGallerySlider = () => {
    let galleries = document.querySelectorAll('.wp-block-gallery.is-style-gallerySlider');
    if (galleries.length > 0) {
        [...galleries].forEach((gallery) => {
            let galHolder = document.createElement('div');
            let caption = gallery.querySelector(':scope .blocks-gallery-caption');
            galHolder.classList.add('wp-block-gallery__slider');
            galHolder.classList.add('slickSliderUi');
            let images = gallery.querySelectorAll(':scope .wp-block-image');
            [...images].forEach((image) => {
                galHolder.appendChild(image);
            });
            gallery.insertBefore(galHolder, gallery.firstChild);

            typeof jQuery == "function" ? jQuery(galHolder).slick({
                infinite: false,
                arrows: true,
                dots: false,
                autoplay: false,
                speed: 500,
                autoplaySpeed: 3000,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            }) : null;


        });
    }
}

export const initLazyBg = (className = 'lazyBg') => {
    let lazyBgList = [].slice.call(document.querySelectorAll('.' + className));

    if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.remove(className);
                    lazyImageObserver.unobserve(entry.target);
                }
            });
        }, {
            rootMargin: '150px 0px'
        });
        lazyBgList.forEach(function (lazyBg) {
            lazyImageObserver.observe(lazyBg);
        });
    }

}

export const animUp = (className = 'animUp') => {
    let lazyBgList = [].slice.call(document.querySelectorAll('.' + className));

    if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.remove(className);
                    lazyImageObserver.unobserve(entry.target);
                }
            });
        }, {
            rootMargin: '150px 0px'
        });
        lazyBgList.forEach(function (lazyBg) {
            lazyImageObserver.observe(lazyBg);
        });
    }


}

export const initCounting = () => {
    const items = document.querySelectorAll('span.counting');
    if (!items.length) return;

    items.forEach(el => {
        const original = el.textContent.trim();
        const num = parseFloat(original.replace(/\s/g, '').replace(',', '.'));
        if (isNaN(num)) return;

        // Determine decimal places from original format (using comma or dot)
        const match = original.replace(/\s/g, '').match(/[.,](\d+)$/);
        const decimals = match ? match[1].length : 0;

        // Check if original uses space as thousands separator
        const usesSpaces = /\d\s\d/.test(original);
        // Check if original uses comma as decimal separator
        const usesComma = /,\d+$/.test(original.replace(/\s/g, ''));

        // Store prefix/suffix (e.g. "+" at end, currency symbols, etc.)
        const prefixMatch = original.match(/^([^\d]*)/);
        const suffixMatch = original.match(/([^\d\s.,]*)$/);
        const prefix = prefixMatch ? prefixMatch[1] : '';
        const suffix = suffixMatch ? suffixMatch[1] : '';

        el.setAttribute('data-counting', num);
        el.setAttribute('data-counting-decimals', decimals);
        el.setAttribute('data-counting-spaces', usesSpaces ? '1' : '0');
        el.setAttribute('data-counting-comma', usesComma ? '1' : '0');
        el.setAttribute('data-counting-prefix', prefix);
        el.setAttribute('data-counting-suffix', suffix);
        el.textContent = prefix + '0' + suffix;
    });

    const formatNumber = (value, decimals, usesSpaces, usesComma) => {
        let str = value.toFixed(decimals);
        if (usesComma && decimals > 0) {
            str = str.replace('.', ',');
        }
        if (usesSpaces) {
            const parts = str.split(/[.,]/);
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
            if (parts[1] !== undefined) {
                str = parts[0] + (usesComma ? ',' : '.') + parts[1];
            } else {
                str = parts[0];
            }
        }
        return str;
    };

    const duration = 2000;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            const el = entry.target;
            observer.unobserve(el);

            const target = parseFloat(el.getAttribute('data-counting'));
            const decimals = parseInt(el.getAttribute('data-counting-decimals'));
            const usesSpaces = el.getAttribute('data-counting-spaces') === '1';
            const usesComma = el.getAttribute('data-counting-comma') === '1';
            const prefix = el.getAttribute('data-counting-prefix');
            const suffix = el.getAttribute('data-counting-suffix');

            let start = null;
            const step = (timestamp) => {
                if (!start) start = timestamp;
                const progress = Math.min((timestamp - start) / duration, 1);
                // easeOutQuart for smooth deceleration
                const eased = 1 - Math.pow(1 - progress, 4);
                const current = eased * target;

                el.textContent = prefix + formatNumber(current, decimals, usesSpaces, usesComma) + suffix;

                if (progress < 1) {
                    requestAnimationFrame(step);
                }
            };
            requestAnimationFrame(step);
        });
    }, {
        rootMargin: '0px 0px -15% 0px'
    });

    items.forEach(el => {
        if (el.hasAttribute('data-counting')) {
            observer.observe(el);
        }
    });
};

export const initShow = (className = 'animUp', classNameAdd = 'show') => {
    let showList = [].slice.call(document.querySelectorAll('.' + className));

    if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add(classNameAdd);
                    lazyImageObserver.unobserve(entry.target);
                } /*else {
                    entry.target.classList.remove(classNameAdd); 
                }*/
            });
        }, {
            rootMargin: '0px 0px -15% 0px'
        });
        showList.forEach(function (show) {
            lazyImageObserver.observe(show);
        });
    }

}


/**
 * 
 * cart start
 */
const updateOrderCount = (count = 0) => {
    const btn = document.querySelector('.cart.menu-item a');
    if (count != 0) {
        btn.dataset.num = '(' + count + ')';
        btn.classList.add('withNum');

    } else {
        btn.classList.remove('withNum');
        btn.dataset.num = '';
    }
}


const hideInfo = () => {
    const info = document.querySelector('.addToCartInfo');
    info.classList.remove('show');
}
let closeTimeout;

const showInfo = (item, type) => {
    const info = document.querySelector('.addToCartInfo');
    const itemName = item.parentNode.querySelector(':scope .offerList__title').innerHTML;
    info.classList.add('show');
    const texts = info.querySelectorAll(':scope .addToCartInfo__text');
    if (texts) {
        [...texts].forEach((t => t.classList.remove('active')));
    }


    info.querySelector(':scope .addToCartInfo__text.' + type).classList.add('active');

    info.querySelector(':scope .addToCartInfo__text.' + type + ' .productName').innerHTML = itemName;

    if (closeTimeout) {
        clearTimeout(closeTimeout);
    }
    closeTimeout = window.setTimeout(() => {
        hideInfo();
    }, 3000);



}

const addToCart = (id, item) => {
    if (id) {
        const formData = new FormData();
        formData.append('action', 'addToCart');
        formData.append('id', id);
        item.classList.add('load');
        fetch(ajaxParams.ajaxurl, {
            method: "post",
            body: formData
        }).then(res => res.text())
            .then(res => {
                res = JSON.parse(res);
                if (res.status == 'added') {
                    item.classList.add('added');
                    showInfo(item, 'added');
                } else {
                    showInfo(item, 'error');
                }
                item.classList.remove('load');
                updateOrderCount(res.count);

            });


    }
}
const removeFromCart = (id, item = null) => {
    if (id) {
        const formData = new FormData();
        formData.append('action', 'removeFromCart');
        formData.append('id', id);
        if (item)
            item.classList.add('load');
        fetch(ajaxParams.ajaxurl, {
            method: "post",
            body: formData
        }).then(res => res.text())
            .then(res => {
                res = JSON.parse(res);
                if (res.status == 'unset') {
                    if (item)
                        item.classList.remove('added');
                    if (item)
                        showInfo(item, 'deleted');
                } else {
                    if (item)
                        showInfo(item, 'error');
                }
                if (item)
                    item.classList.remove('load');
                updateOrderCount(res.count);

            });


    }
}



export const initCartCalc = () => {
    const inputs = document.querySelectorAll('.cartFormList input');
    const delBtns = document.querySelectorAll('.cartItem__delete');

    // console.log(inputs);
    const cartCalc = () => {
        const items = document.querySelectorAll('.cartItem');
        let out = '';
        let temp = [];

        [...items].forEach((item) => {
            temp.push(
                {
                    name: item.querySelector(':scope .cartItem__title').innerHTML,
                    cat: item.querySelector(':scope .cartItem__title').dataset.cat,
                    amount: item.querySelector(':scope .cartItem__count').value,
                    delivery: item.querySelector(':scope .cartItem__date').value
                }
            );

        });
        console.log(temp);




        temp.sort(function (a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return ('' + a.cat).localeCompare(b.cat) || new Date(a.delivery) - new Date(b.delivery);
        });
        console.log(temp);

        if (items) {
            out = '<table style="border-collapse: collapse;"><thead><tr><th style="padding:5px 10px; border:1px solid #557785;">Kategoria</th><th style="padding:5px 10px; border:1px solid #557785;">Nazwa</th><th  style="padding:5px 10px; border:1px solid #557785;">Ilość</th><th  style="padding:5px 10px; border:1px solid #557785;">Termin dostawy</th></tr></thead><tbody>';
            temp.forEach((item) => {
                // const name = item.querySelector(':scope .cartItem__title').innerHTML;
                // const amount = item.querySelector(':scope .cartItem__count').value;
                // const delivery = item.querySelector(':scope .cartItem__date').value;
                out += '<tr><td  style="padding:5px 10px; border:1px solid #557785;">' + item.cat + '</td><td  style="padding:5px 10px; border:1px solid #557785;">' + item.name + '</td><td  style="padding:5px 10px; border:1px solid #557785;">' + item.amount + '</td><td  style="padding:5px 10px; border:1px solid #557785;">' + item.delivery + '</td></tr>';
            });
            out += '</tbody></table>';
        }
        console.log(out);

        document.querySelector('textarea[name=formOrder]').value = out;
    }
    const deleteItem = (item) => {
        if (item) {
            item.parentNode.remove();
            removeFromCart(item.dataset.id);
            cartCalc();
        }
    }

    if (inputs) {
        [...inputs].forEach((item) => {
            item.addEventListener('input', () => cartCalc());
        });
    }
    if (delBtns) {
        [...delBtns].forEach((item) => {
            item.addEventListener('click', () => deleteItem(item));
        });
    }
    if (document.querySelector('.cartFormList')) {
        cartCalc();
    }

}

const getCartCount = () => {
    const formData = new FormData();
    formData.append('action', 'getCartCount');
    fetch(ajaxParams.ajaxurl, {
        method: "post",
        body: formData
    }).then(res => res.text())
        .then(res => {
            updateOrderCount(res);
            console.log(res);
        });
}

export const initAddToCard = () => {
    const btns = document.querySelectorAll('.addToCart');
    const closeBtn = document.querySelector('.addToCartInfo__close');


    [...btns].forEach((item) => {
        item.addEventListener('click', () => {
            if (item.classList.contains('added')) {
                removeFromCart(item.dataset.id, item);
            } else {
                addToCart(item.dataset.id, item);
            }
        });
    });
    getCartCount();



    if (closeBtn) {
        closeBtn.addEventListener('click', (e) => {
            e.preventDefault()
            hideInfo();
            return false;
        });
    }
}

/**
 * cart end
 */
